import { render, staticRenderFns } from "./Attributes-modal.vue?vue&type=template&id=823c8862&scoped=true"
import script from "./Attributes-modal.vue?vue&type=script&lang=js"
export * from "./Attributes-modal.vue?vue&type=script&lang=js"
import style0 from "./Attributes-modal.vue?vue&type=style&index=0&id=823c8862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823c8862",
  null
  
)

export default component.exports